import { render, staticRenderFns } from "./ListSubmission.vue?vue&type=template&id=7097510d&scoped=true&"
import script from "./ListSubmission.vue?vue&type=script&lang=js&"
export * from "./ListSubmission.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7097510d",
  null
  
)

export default component.exports